import { ConfigParser, ConfigParserError } from 'core/config/config-parser';
import { EventTrackingConfig } from './event-tracking-config';

export class EventTrackingConfigParser extends ConfigParser
{
  /**
   * @throws ConfigParserError
   */
  public getConfig(): EventTrackingConfig | false
  {
    const tracking = this.genericConfigObject;
    if (this.genericConfigObject === undefined) {
      return false;
    }

    this.validateConfig();
    return <EventTrackingConfig> {
      type: tracking.type,
      debug: tracking.debug ? tracking.debug : false,
      conversionLabels: tracking.conversion_labels ?
          tracking.conversion_labels : [],
      id: tracking.id || undefined,
      targetOrigin: tracking.target_origin || undefined,
    };
  }

  /**
   * @throws ConfigParserError
   */
  private validateConfig(): void
  {
    const tracking = this.genericConfigObject;
    if (tracking.type === undefined || tracking.type.length === 0) {
      throw new ConfigParserError('tracking type is undefined');
    }
    else if (tracking.type === 'google_analytics') {
      if (tracking.id === undefined || tracking.id.length === 0) {
        throw new ConfigParserError('tracking id is undefined');
      }
    }
    else if (tracking.type === 'post_message') {
      if (tracking.target_origin === undefined
          || tracking.target_origin.length === 0)
      {
        throw new ConfigParserError('target origin is undefined');
      }
    }
  }
}
